import React from 'react';

interface ITelegramProps {
    size?: number;
    color?: string;
}

export const Telegram: React.FC<ITelegramProps> = ({ size = 24, color= "#64469E" }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.23723 11.4575C7.06997 9.34082 10.2918 7.94526 11.9027 7.27105C16.5076 5.3458 17.4632 5.01143 18.0874 5.0001C18.2247 4.99789 18.5303 5.032 18.7297 5.19411C18.8954 5.33083 18.9421 5.51572 18.9654 5.64554C18.9861 5.77522 19.0146 6.07079 18.9913 6.30152C18.7426 8.93692 17.6627 15.3322 17.1136 18.284C16.8831 19.5329 16.4247 19.9517 15.9818 19.9926C15.0184 20.0816 14.288 19.353 13.3557 18.7387C11.8975 17.777 11.074 17.1785 9.65728 16.2403C8.02047 15.1559 9.08232 14.5598 10.0147 13.5858C10.2581 13.3309 14.5004 9.45202 14.5807 9.1002C14.591 9.05619 14.6014 8.89213 14.503 8.80567C14.4072 8.71895 14.2647 8.74864 14.1611 8.77208C14.0135 8.80541 11.6852 10.3544 7.16839 13.4187C6.50797 13.8754 5.9097 14.0981 5.371 14.0864C4.78051 14.0736 3.64095 13.7499 2.79405 13.4733C1.7581 13.134 0.931918 12.9546 1.00443 12.3783C1.04069 12.0783 1.45249 11.7713 2.23723 11.4575Z"
                fill={color}/>
        </svg>

    );
};
